import Getters from './getters'
import Util from './util'
import dayjs from 'dayjs'
import { namespace } from './env'

export default class Mutations {
  constructor () {
    this.gettersInstance = new Getters()
    this.utilInstance = new Util()
    this.properties = {
      data: [],
      viewData: [],
      page: 1,
      perPage: 12,
      totalPage: 1,
      count: 0
    }
    this.stationsData = {}
    this.selectStations = []
    this.select = [
      { key: 'releaseDate', value: '新着順', selected: true },
      { key: 'rangePrice', value: '価格順', selected: false }
    ]
  }

  setRailwayData (array) {
    const { Routes } = JSON.parse(sessionStorage.getItem(namespace.STATIONS_JSON))
    let railway = Array.from(Routes)
    let sts = []

    railway.map((t) => {
      let railroad = {
        viewName: t.viewName,
        routeName: t.RouteName,
        stations: []
      }

      let station = {}
      for (const [key, value] of Object.entries(t.StationInformation)) {
        let arr = []
        if (value.BranchName === undefined) {
          arr = Object.assign([], value)
          arr.splice(0)
          railroad.stations.push(arr)
        } else {
          arr = Object.assign([], value.line)
          arr.splice(0)
          railroad.stations.push(arr)
        }

        let lines = []
        if (t.StationInformation[key].BranchName !== undefined) {
          lines = Object.assign([], t.StationInformation[key].line)
        } else {
          lines = Object.assign([], t.StationInformation[key])
        }

        lines.map((s) => {
          station = {
            branch: t.StationInformation[key].BranchName ? t.StationInformation[key].BranchName : '',
            name: s.name,
            count: array.filter((item) => item[this.utilInstance.formulaProperties(item)] === s.name).length,
            select: array.filter((item) => item[this.utilInstance.formulaProperties(item)] === s.name).length !== 0 ? true : false
          }

          if (array.filter((item) => item[this.utilInstance.formulaProperties(item)] === s.name).length !== 0) {
            this.selectStations.push(s.name)
          }

          if (railroad.stations[Number(key.slice(-1)) - 1].BranchName !== undefined) {
            railroad.stations[Number(key.slice(-1)) - 1].push(station)
          } else {
            railroad.stations[Number(key.slice(-1)) - 1].push(station)
          }
        })
      }

      sts.push(railroad)
    })

    this.stationsData = Object.assign([], sts)
    sessionStorage.setItem(namespace.SELECT_STATIONS, JSON.stringify(this.selectStations))
    sessionStorage.setItem(namespace.STATION_DATA, JSON.stringify(this.stationsData))
    this.gettersInstance.getStationList(sts, this.selectStations)
  }

  // ページング表示用データ
  setShapingData (arr) {
    let sortArr = []
    sortArr = Object.assign([], this.sortPropertyData('新着順', arr))

    this.properties.data = sortArr
    this.properties.totalPage = Math.ceil(Object.assign([], arr).length / this.properties.perPage)
    this.properties.count = Object.assign([], arr).length
    this.setStateShapingViewData(1)

    sessionStorage.setItem(namespace.PROPERTIES, JSON.stringify(this.properties))
    this.gettersInstance.getPropertiesData(
      this.properties.viewData,
      this.select,
      this.properties.data.length
    )
    this.gettersInstance.getPaginationData(this.properties)
  }

  async changeSortData (key) {
    await this.setSessionStorageProperties(this.properties.page, key)
    this.gettersInstance.getPropertiesData(
      this.properties.viewData,
      this.select,
      this.properties.data.length
    )
  }

  sortPropertyData (key, array) {
    let properties = []
    const conditions = JSON.parse(sessionStorage.getItem(namespace.CONDITION_JSON))

    this.select.map((s) => {
      if (s.value === key) {
        s.selected = true
      } else {
        s.selected = false
      }
      return {
        s
      }
    })

    if (sessionStorage.getItem(namespace.SORT_DATA) === undefined || sessionStorage.getItem(namespace.SORT_DATA) === null) {
      sessionStorage.setItem(namespace.SORT_DATA, JSON.stringify(this.select))
    } else {
      sessionStorage.removeItem(namespace.SORT_DATA)
      sessionStorage.setItem(namespace.SORT_DATA, JSON.stringify(this.select))
    }

    if (key === '新着順') {
      properties = array.sort((a, b) => dayjs(b[conditions.updateDate]) - dayjs(a[conditions.updateDate]))
    } else if (key === '価格順') {
      properties = array.sort((a, b) => a[conditions.forDetermination] - b[conditions.forDetermination])
    }

    return properties
  }

  clickPrevButton () {
    this.properties = Object.assign({}, JSON.parse(sessionStorage.getItem(namespace.PROPERTIES)))
    sessionStorage.removeItem(namespace.PROPERTIES)

    this.select = Object.assign([], JSON.parse(sessionStorage.getItem(namespace.SORT_DATA)))
    let key = ''
    this.select.map((item) => {
      if (item.selected) {
        key = item.value
      }
    })

    this.sortPropertyData(key, this.properties.data)
    this.setStateShapingViewData(this.properties.page - 1)
    sessionStorage.setItem(namespace.PROPERTIES, JSON.stringify(this.properties))

    this.gettersInstance.getPropertiesData(
      this.properties.viewData,
      this.select,
      this.properties.data.length
    )
    this.gettersInstance.getPaginationData(this.properties)
  }

  clickNextButton () {
    this.properties = Object.assign({}, JSON.parse(sessionStorage.getItem(namespace.PROPERTIES)))
    sessionStorage.removeItem(namespace.PROPERTIES)

    this.select = Object.assign([], JSON.parse(sessionStorage.getItem(namespace.SORT_DATA)))
    let key = ''
    this.select.map((item) => {
      if (item.selected) {
        key = item.value
      }
    })

    this.sortPropertyData(key, this.properties.data)
    this.setStateShapingViewData(this.properties.page + 1)
    sessionStorage.setItem(namespace.PROPERTIES, JSON.stringify(this.properties))

    this.gettersInstance.getPropertiesData(
      this.properties.viewData,
      this.select,
      this.properties.data.length
    )
    this.gettersInstance.getPaginationData(this.properties)
  }

  // ページ遷移
  async transitionViewPropertyData (num) {
    this.select = Object.assign([], JSON.parse(sessionStorage.getItem(namespace.SORT_DATA)))
    let key = ''
    this.select.map((item) => {
      if (item.selected) {
        key = item.value
      }
    })

    await this.setSessionStorageProperties(num, key)

    this.gettersInstance.getPropertiesData(
      this.properties.viewData,
      this.select,
      this.properties.data.length
    )
    this.gettersInstance.getPaginationData(this.properties)
  }

  setStateShapingViewData (num) {
    this.properties.page = num
    this.properties.viewData = this.properties.data.filter(
      (item, i) =>
      i >= (this.properties.page - 1) * this.properties.perPage &&
      i < this.properties.page * this.properties.perPage
    )
  }

  async allClearSelectStation () {
    let arr = await Object.assign([], JSON.parse(sessionStorage.getItem(namespace.ORIGINAL_PROPERTIES)))
    this.select = Object.assign([], JSON.parse(sessionStorage.getItem(namespace.SORT_DATA)))

    let key = ''
    this.select.map((item) => {
      if (item.selected) {
        key = item.value
      }
    })
    sessionStorage.removeItem(namespace.SORT_DATA)
    sessionStorage.setItem(namespace.SORT_DATA, JSON.stringify(this.select))

    let sortArr = []
    sortArr = Object.assign([], this.sortPropertyData(key, arr))

    this.properties.data = sortArr
    this.properties.totalPage = Math.ceil(Object.assign([], arr).length / this.properties.perPage)
    this.properties.count = Object.assign([], arr).length
    this.setStateShapingViewData(1)

    sessionStorage.setItem(namespace.PROPERTIES, JSON.stringify(this.properties))

    this.selectStations = []

    sessionStorage.removeItem(namespace.SELECT_STATIONS)
    sessionStorage.removeItem(namespace.STATION_DATA)

    const { Routes } = JSON.parse(sessionStorage.getItem(namespace.STATIONS_JSON))
    let railway = Array.from(Routes)
    let sts = []

    railway.map((t) => {
      let railroad = {
        viewName: t.viewName,
        routeName: t.RouteName,
        stations: []
      }

      let station = {}
      for (const [key, value] of Object.entries(t.StationInformation)) {
        let arr = []
        if (value.BranchName === undefined) {
          arr = Object.assign([], value)
          arr.splice(0)
          railroad.stations.push(arr)
        } else {
          arr = Object.assign([], value.line)
          arr.splice(0)
          railroad.stations.push(arr)
        }

        let lines = []
        if (t.StationInformation[key].BranchName !== undefined) {
          lines = Object.assign([], t.StationInformation[key].line)
        } else {
          lines = Object.assign([], t.StationInformation[key])
        }

        lines.map((s) => {
          station = {
            branch: t.StationInformation[key].BranchName ? t.StationInformation[key].BranchName : '',
            name: s.name,
            count: this.properties.data.filter((item) => item[this.utilInstance.formulaProperties(item)] === s.name).length,
            select: false
          }

          if (railroad.stations[Number(key.slice(-1)) - 1].BranchName !== undefined) {
            railroad.stations[Number(key.slice(-1)) - 1].push(station)
          } else {
            railroad.stations[Number(key.slice(-1)) - 1].push(station)
          }
        })
      }

      sts.push(railroad)
    })

    this.stationsData = Object.assign([], sts)
    sessionStorage.setItem(namespace.SELECT_STATIONS, JSON.stringify(this.selectStations))
    sessionStorage.setItem(namespace.STATION_DATA, JSON.stringify(this.stationsData))
    this.gettersInstance.getStationList(sts, this.selectStations)
  }

  allSelectStation () {
    if (this.selectStations.length) {
      this.selectStations = []
    }

    sessionStorage.removeItem(namespace.SELECT_STATIONS)
    sessionStorage.removeItem(namespace.STATION_DATA)

    let key = ''
    this.select.map((item) => {
      if (item.selected) {
        key = item.value
      }
    })
    sessionStorage.removeItem(namespace.SORT_DATA)
    sessionStorage.setItem(namespace.SORT_DATA, JSON.stringify(this.select))

    let arr = JSON.parse(sessionStorage.getItem(namespace.ORIGINAL_PROPERTIES))
    let sortArr = []
    sortArr = Object.assign([], this.sortPropertyData(key, arr))

    this.properties.data = sortArr
    this.properties.totalPage = Math.ceil(Object.assign([], arr).length / this.properties.perPage)
    this.properties.count = Object.assign([], arr).length
    this.setStateShapingViewData(this.properties.page)

    this.setRailwayData(this.properties.data)
  }

  // 駅単一選択
  async getSelectStationProperty (value, rid) {
    this.selectStations = JSON.parse(sessionStorage.getItem(namespace.SELECT_STATIONS))
    this.select = Object.assign([], JSON.parse(sessionStorage.getItem(namespace.SORT_DATA)))

    let key = ''
    this.select.map((item) => {
      if (item.selected) {
        key = item.value
      }
    })
    sessionStorage.removeItem(namespace.SORT_DATA)
    sessionStorage.setItem(namespace.SORT_DATA, JSON.stringify(this.select))

    await this.setSessionStorageProperties(1, key)

    if (this.selectStations.find(name => name === value) === undefined) {
      this.selectStations.push(value)
    } else {
      let idx = this.selectStations.indexOf(value)
      this.selectStations.splice(idx, 1)
    }

    this.stationsData = JSON.parse(sessionStorage.getItem(namespace.STATION_DATA))
    const stations = Object.assign([], this.stationsData)
    stations[Number(rid)].stations.map(arr => {
      arr.find(s => s.name === value).select = !arr.find(s => s.name === value).select
    })

    this.stationsData = stations
    sessionStorage.removeItem(namespace.SELECT_STATIONS)
    sessionStorage.removeItem(namespace.STATION_DATA)
    sessionStorage.setItem(namespace.STATION_DATA, JSON.stringify(this.stationsData))
    sessionStorage.setItem(namespace.SELECT_STATIONS, JSON.stringify(this.selectStations))
    this.gettersInstance.getStationList(stations, this.selectStations)
  }

  async narrowingStationProperty () {
    this.selectStations = JSON.parse(sessionStorage.getItem(namespace.SELECT_STATIONS))

    this.select = Object.assign([], JSON.parse(sessionStorage.getItem(namespace.SORT_DATA)))
    let key = ''
    this.select.map((item) => {
      if (item.selected) {
        key = item.value
      }
    })

    let arr = await Object.assign([], JSON.parse(sessionStorage.getItem(namespace.ORIGINAL_PROPERTIES)))
    let properties = []
    this.selectStations.map((s) => {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i][this.utilInstance.formulaProperties(arr[i])] === s) {
          properties.push(arr[i])
        }
      }
    })
    let sortArr = []
    sortArr = Object.assign([], this.sortPropertyData(key, properties))

    this.properties.data = sortArr
    this.properties.totalPage = Math.ceil(Object.assign([], sortArr).length / this.properties.perPage)
    this.properties.count = Object.assign([], sortArr).length
    this.setStateShapingViewData(1)

    sessionStorage.setItem(namespace.PROPERTIES, JSON.stringify(this.properties))
    this.gettersInstance.getPropertiesData(
      this.properties.viewData,
      this.select,
      this.properties.data.length
    )
    this.gettersInstance.getPaginationData(this.properties)
  }

  async setSessionStorageProperties (num, key) {
    this.properties = Object.assign({}, JSON.parse(sessionStorage.getItem(namespace.PROPERTIES)))
    sessionStorage.removeItem(namespace.PROPERTIES)

    this.sortPropertyData(key, this.properties.data)

    if (num === undefined || num === null) {
      this.setStateShapingViewData(this.properties.page)
    } else {
      this.setStateShapingViewData(num)
    }
    await sessionStorage.setItem(namespace.PROPERTIES, JSON.stringify(this.properties))
  }
}
